<template>
  <div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3 mr-r15 vertical-center-box">적용 대상 목록</div>
        <w-check-obj-table-popup-button class="mr-r4" type="physical" :checked-obj-list="checkedObjList" selected-managetype-id="VMS" @change-obj-list="changeObjList"
        :disabled="!selectedRule" />
      </div>
      <div class="vertical-center-box" align="right">
        <w-header-search-button @click="toggleSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper ref="targetTable" :column-default="columnDefault" :data="ruleTargetData" :columns="ruleTargetColumns" remote pagination
    :total="total" highlight-current-row :show-custom-header="true" :show-search-tool="showSearchTool" @condition-change="loadData">
    </el-table-wrapper>
  </div>
</template>

<script>
import { difference, cloneDeep, isEmpty, isNil, isEqual } from 'lodash';
import msgUtil from '@/utils/message';
import { EMPTY_TEXT } from '@/utils/string';
import { columnDefault } from '@/constants/table';
import virtuallogSettingAPI from '@/api/settings/log/virtuallog-settings';
import WCheckObjTablePopupButton from '@/components/button/CheckObjTablePopupButton';

export default {
  name: 'WVirtuallogRuleTargetTable',
  props: {
    selectedRule: {
      type: Object,
    },
  },
  components: {
    WCheckObjTablePopupButton,
  },
  data() {
    const ruleTargetColumns = [
      {
        prop: 'objName',
        label: '장비명',
        searchable: true,
        remoteProp: 'obj_name',
        sortable: true,
        formatter: this.getStringFormatter,
      },
      {
        prop: 'ipaddress',
        label: 'IP주소',
        searchable: true,
        sortable: true,
        formatter: this.getStringFormatter,
      },
      {
        prop: 'objtypeName',
        label: '구분',
        searchable: true,
        remoteProp: 'objtype_name',
        sortable: true,
        formatter: this.getStringFormatter,
      },
    ];
    return {
      showSearchTool: false,
      ruleTargetData: [],
      total: 0,
      ruleTargetColumns,
      selectedRow: null,
      columnDefault,
      checkedObjList: [],
      originCheckedObjIds: [],
      exceptObjDefineIds: [],
    };
  },
  watch: {
    selectedRule: {
      immediate: true,
      handler(value) {
        if (!isEmpty(value) && !isNil(value.logPolicyId)) {
          this.loadData();
        } else {
          this.ruleTargetData = [];
        }
      },
    },
  },
  computed: {
    logPolicyId() {
      return isEmpty(this.selectedRule) || isNil(this.selectedRule.logPolicyId) ? null : this.selectedRule.logPolicyId;
    },
  },
  mounted() {
    virtuallogSettingAPI.getObjDefineIdList().then((response) => {
      if (response.data.success) {
        this.exceptObjDefineIds = response.data.data;
      }
    }).catch((e) => {
      throw new Error(e);
    });
  },
  methods: {
    /**
     * 정책 목록에서 선택한 Rule의 적용 대상 목록을 불러온다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    loadData() {
      this.updateTarget();
      const tableParams = this.$refs.targetTable.getParameter();
      const params = {
        logPolicyId: this.selectedRule.logPolicyId,
        ...tableParams,
      };
      virtuallogSettingAPI.getVmsLogPolicyTargetList(params).then((response) => {
        const result = response.data.data;
        this.ruleTargetData = cloneDeep(result);
        this.total = response.data.total;
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '적용 대상 목록', false));
        throw new Error(e);
      });
    },
    getStringFormatter(row, column, value) {
      if (!isEmpty(value)) {
        return value;
      }
      return EMPTY_TEXT;
    },
    updateTarget() {
      const params = {
        logPolicyId: this.selectedRule.logPolicyId,
      };
      virtuallogSettingAPI.getVmsLogPolicyTargetList(params).then((response) => {
        if (response.data.success) {
          const result = response.data.data;
          this.checkedObjList = cloneDeep(result);
          const originCheckedObjIds = [];
          if (this.checkedObjList.length > 0) {
            this.checkedObjList.forEach((obj) => {
              if (!originCheckedObjIds.includes(obj.objId)) {
                originCheckedObjIds.push(obj.objId);
              }
            });
          }
          this.originCheckedObjIds = originCheckedObjIds;
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '적용 대상 목록', false));
        throw new Error(e);
      });
    },
    toggleSearchTool() {
      this.showSearchTool = !this.showSearchTool;
    },
    onSelectionChange(selection) {
      this.checkedRows = selection;
    },
    changeObjList(selectedObjList) {
      const checkedObjIds = [];
      selectedObjList.forEach((obj) => {
        if (!checkedObjIds.includes(obj.objId)) {
          checkedObjIds.push(obj.objId);
        }
      });
      checkedObjIds.sort((a, b) => (a - b));

      const insertObjIds = difference(checkedObjIds, this.originCheckedObjIds);
      const deleteObjIds = difference(this.originCheckedObjIds, checkedObjIds);
      let logPolicyType;
      if (isEqual(this.selectedRule.logPolicyType, 'ALARM')) {
        logPolicyType = 'ALARM_LOG';
      } else if (isEqual(this.selectedRule.logPolicyType, 'EVENT')) {
        logPolicyType = 'EVENT_LOG';
      } else {
        logPolicyType = 'TASK_LOG';
      }
      const objList = [];
      const target = '관리 대상';
      const action = msgUtil.action.SAVE;
      insertObjIds.forEach((objId) => {
        objList.push({
          objId,
          logPolicyId: this.selectedRule.logPolicyId,
          label: logPolicyType,
          sql_type: 'INSERT',
        });
      });
      deleteObjIds.forEach((objId) => {
        objList.push({
          objId,
          logPolicyId: this.selectedRule.logPolicyId,
          label: logPolicyType,
          sql_type: 'DELETE',
        });
      });
      virtuallogSettingAPI.updateVmsLogPolicyTargetList(objList).then((response) => {
        const result = response.data;
        if (result.success === true) {
          this.$message(msgUtil.getResultMsgData(action, target, true));
          this.loadData();
        } else {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(action, target, false));
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/log/Virtuallog/components/VirtuallogRuleTargetTable.vue